module.exports = __webpack_public_path__ + "img/nuki-smartlock-lg.c2b7a3ea.svg";